// extracted by mini-css-extract-plugin
export var cancelButton = "_oy-5";
export var content = "_oy-3";
export var createButton = "_oy-6";
export var drawerContainer = "_oy-0";
export var footer = "_oy-2";
export var header = "_oy-1";
export var orderFormColumn = "_oy-4";